<template>
  <span class="tag" :class="getStatusClass()">
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: 'Tag',
  props: [],
  data() {
    return {};
  },
  methods: {
    getStatusClass() {
      switch (this.$slots.default[0].text.toLowerCase()) {
        case 'none':
          return 'grey';
        case 'good':
          return 'green';
        case 'completed':
          return 'green';
        case 'available':
          return 'outline-green';
        case 'short':
          return 'outline-orange';
        case 'missing':
          return 'outline-orange';
        case 'invalid':
          return 'red';
        case 'error':
          return 'red';
        case 'rejected':
          return 'red';
        case 'declined':
          return 'red';
        case 'reversed':
          return 'red';
        case 'failed':
          return 'red';
        case 'cancelled':
          return 'outline-red';
        case 'hold':
          return 'yellow';
        case 'pending':
          return 'yellow';
        case 'submitted':
          return 'light-yellow';
        case 'awaiting_funds':
          return 'outline-blue';
        case 'created':
          return 'blue';
        case 'confirmed':
          return 'blue';
        default:
          return '';
      }
    },
  },
};
</script>
<style lang="scss">
span.tag {
  text-transform: capitalize;
  padding: 3px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  background-color: antiquewhite;

  &.green {
    background-color: green;
    color: white;
  }

  &.outline-green {
    background-color: white;
    border-color: green;
    color: green;
  }

  &.yellow {
    background-color: orange;
  }

  &.outline-orange {
    background-color: white;
    border-color: orange;
    color: orange;
  }

  &.light-yellow {
    background-color: moccasin;
  }

  &.red {
    background-color: #8c2222;
    color: white;
  }

  &.outline-red {
    background-color: white;
    border-color: #8c2222;
    color: #8c2222;
  }

  &.grey {
    background-color: grey;
    color: white;
  }

  &.blue {
    color: white;
    background-color: rgb(72, 72, 203);
  }

  &.outline-blue {
    background-color: white;
    color: rgb(72, 72, 203);
    border-color: rgb(72, 72, 203);
  }
}
</style>
